export const ADD_ANALYTICS_DATE = 'ADD_ANALYTICS_DATE';
export const SUBTRACT_ANALYTICS_DATE = 'SUBTRACT_ANALYTICS_DATE';

export const SET_ANALYTICS_DATE = 'SET_ANALYTICS_DATE';
export const SET_ANALYTICS_PERIOD = 'SET_ANALYTICS_PERIOD';
export const SET_ANALYTICS_FILTER = 'SET_ANALYTICS_FILTER';
export const SET_ANALYTICS_TIMESLOT = 'SET_ANALYTICS_TIMESLOT';

export const GET_ANALYTICS_CHARTS_REQUEST = 'GET_ANALYTICS_CHARTS_REQUEST';
export const GET_ANALYTICS_CHARTS_FAILURE = 'GET_ANALYTICS_CHARTS_FAILURE';
export const GET_ANALYTICS_CHARTS_SUCCESS = 'GET_ANALYTICS_CHARTS_SUCCESS';

export const GET_ANALYTICS_MAIN_CHART_REQUEST = 'GET_ANALYTICS_MAIN_CHART_REQUEST';
export const GET_ANALYTICS_MAIN_CHART_FAILURE = 'GET_ANALYTICS_MAIN_CHART_FAILURE';
export const GET_ANALYTICS_MAIN_CHART_SUCCESS = 'GET_ANALYTICS_MAIN_CHART_SUCCESS';

export const SET_ANALYTICS_MAIN_LEGEND = 'SET_ANALYTICS_MAIN_LEGEND';

export const GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST = 'GET_ANALYTICS_CAMPAIGN_REPORT_REQUEST';
export const GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS = 'GET_ANALYTICS_CAMPAIGN_REPORT_SUCCESS';
export const GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE = 'GET_ANALYTICS_CAMPAIGN_REPORT_FAILURE';

export const GET_ANALYTICS_CAMPAIGN_LIST_REQUEST = 'GET_ANALYTICS_CAMPAIGN_LIST_REQUEST';
export const GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS = 'GET_ANALYTICS_CAMPAIGN_LIST_SUCCESS';
export const GET_ANALYTICS_CAMPAIGN_LIST_FAILURE = 'GET_ANALYTICS_CAMPAIGN_LIST_FAILURE';

export const SET_ANALYTICS_LIVE_STREAM_STATS = 'SET_ANALYTICS_LIVE_STREAM_STATS';



// WEBPACK FOOTER //
// ./src/store/modules/analytics/mutation-types.js